export const RECALL_STATES = Object.freeze({
    ISSUED: "ISSUED",
    CANCELED: "CANCELED",
    DISPUTED: "DISPUTED",
});
